import { TemplateStateHandler } from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';
import { Subject } from 'rxjs';
import { UapDomManager } from '../../helpers/uap-dom-manager';

/**
 * This handler sets the slot height impact and placeholder height impact.
 */
@Injectable({ autobind: false })
export class BflaSlotSizeImpactWithPlaceholderHandler implements TemplateStateHandler {
	private unsubscribe$ = new Subject<void>();

	constructor(private manager: UapDomManager) {}

	async onEnter(): Promise<void> {
		this.manager.setSlotHeightImpact();
		this.manager.setPlaceholderHeightImpact();
	}

	async onLeave(): Promise<void> {
		this.unsubscribe$.next();
	}
}
